import React from 'react'

export const useClipboardFeedback = (timeout = 2000): [boolean, (text: string) => void] => {
  const [copied, setCopied] = React.useState(false)

  const copy = React.useCallback(
    (text: string) => {
      navigator.clipboard.writeText(text).then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), timeout)
      })
    },
    [timeout],
  )

  return [copied, copy]
}
